import FaqComp from "../sharedLandingcomponents/Faq_Comp";
import HeroComp from "../sharedLandingcomponents/Hero_Comp";
import PortServicesCompMini from "../sharedLandingcomponents/portfolio_Service_mini";
import InventoryFaqComp from "../sharedLandingcomponents/Product_Inventory/Faq_Comp";
import InventoryHeroComp from "../sharedLandingcomponents/Product_Inventory/Hero_Comp";
import InventoryFeaturesComp from "../sharedLandingcomponents/Product_Inventory/inventory_features";
import InventoryIndustriesComp from "../sharedLandingcomponents/Product_Inventory/inventory_industry_serve";
import InventoryMonitorBusinessComp from "../sharedLandingcomponents/Product_Inventory/Inventory_Monitor_business";
import InventoryAdvancePricingComp from "../sharedLandingcomponents/Product_Inventory/inventory_pricing";
import InventoryPricingMiniComp from "../sharedLandingcomponents/Product_Inventory/inventory_pricing_mini";
import InventorySalesFunnelComp from "../sharedLandingcomponents/Product_Inventory/inventory_sales_funnel_test";
import InventoryTestimonyComp from "../sharedLandingcomponents/Product_Inventory/Inventory_Testimony_Comp";
import InventoryWhyChooseUsComp from "../sharedLandingcomponents/Product_Inventory/inventory_why";
import SkillComp from "../sharedLandingcomponents/skills_Comp";
import SkillFeatureComp from "../sharedLandingcomponents/skills_feature_Comp";
import "../sharedLandingcss/Site.css";
import "../sharedLandingcss/Site_Animate.css";

const ProductInventoryPage = () => {
  return (
    <div className="min-h-[400px]">
      {/* Header */}
      <InventoryHeroComp></InventoryHeroComp>

      {/* Features */}
      <InventoryFeaturesComp></InventoryFeaturesComp>

      {/* Monitor Business Anywhere */}
      <InventoryMonitorBusinessComp></InventoryMonitorBusinessComp>

      {/* Why Choose Us*/}
      <InventoryWhyChooseUsComp></InventoryWhyChooseUsComp>

      <InventoryIndustriesComp></InventoryIndustriesComp>

      {/* Pricing Mini */}
      <InventoryPricingMiniComp></InventoryPricingMiniComp>
{/* 
      <InventorySalesFunnelComp></InventorySalesFunnelComp> */}

      {/* <InventoryAdvancePricingComp></InventoryAdvancePricingComp> */}

      {/* Testimony  */}
      <InventoryTestimonyComp></InventoryTestimonyComp>

      {/* FAQ */}
      <InventoryFaqComp></InventoryFaqComp>
    </div>
  );
};

export default ProductInventoryPage;
